var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.test)?_c('div',[(!_vm.show)?_c('Login'):_vm._e(),(_vm.show)?_c('Main',{on:{"user-logout":_vm.userLogout}}):_vm._e()],1):_c('div',[_c('v-app',{attrs:{"id":"app"}},[_c('router-view',{on:{"update-cart":_vm.updateCart}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }